/*
 * NicheCanvas — T5 drawer interaction tracking (Microsoft Clarity + optional Sheet beacon).
 * For the Intelligems T5 "Min-maxed drawer" variant ONLY (must not ship to the live theme).
 * Captures: frame upsell impression (eligible), upgrade black/white clicks, rush add-on
 * shown, and rush opt-in (robust: the rush product 'priority-processing' entering the cart,
 * not the fragile UpCart toggle DOM). Impressions + opt-in are de-duped once per session.
 * Clarity tags+events fire now; the Sheet beacon stays dormant until window.NCT5_BEACON is set.
 */
(function () {
  'use strict';
  function root() { return window.upcartDocumentOrShadowRoot || null; }

  function once(key) {
    try {
      var k = 'nc_t5_' + key;
      if (sessionStorage.getItem(k)) return false;
      sessionStorage.setItem(k, '1');
      return true;
    } catch (e) { return true; }
  }

  function clar() {
    if (typeof window.clarity !== 'function') return;
    try { window.clarity.apply(null, arguments); } catch (e) {}
  }

  function beacon(type, frame) {
    var url = window.NCT5_BEACON;
    if (!url) return;
    try {
      var payload = JSON.stringify({ t: type, f: frame || '', ts: Date.now() });
      if (navigator.sendBeacon) navigator.sendBeacon(url, payload);
      else fetch(url, { method: 'POST', body: payload, keepalive: true, mode: 'no-cors' });
    } catch (e) {}
  }

  function track(type, frame) {
    clar('event', 'nc_' + type + (frame ? '_' + frame : ''));
    clar('set', type === 'frame_upgrade' ? 'nc_frame_upgrade' : 'nc_' + type, frame || 'yes');
    beacon(type, frame);
  }

  function checkImpressions() {
    var r = root(); if (!r) return;
    if (r.querySelector('.nc-fu') && once('frame_eligible')) track('frame_eligible');
    var title = r.querySelector('.upcart-addons-title');
    if (title && /rush/i.test(title.textContent || '') && once('rush_shown')) track('rush_shown');
  }

  function onClick(e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.classList && el.classList.contains('nc-fu__btn')) {
        var frame = el.querySelector('.nc-fu__frame--black') ? 'black'
          : (el.querySelector('.nc-fu__frame--white') ? 'white' : 'unknown');
        track('frame_upgrade', frame);
        return;
      }
    }
  }

  function onCart(c) {
    var hasRush = ((c && c.items) || []).some(function (i) {
      return i.handle === 'priority-processing'
        || (i.properties && i.properties.__upcartAddon)
        || /rush/i.test(i.title || '');
    });
    if (hasRush && once('rush_optin')) track('rush_optin');
  }

  // nc-drawer-minmax.js reads the cart on the same drawer renders through the shared reader
  // (assets/nc-drawer-cart.js): look at those reads instead of fetching cart.js again (TH-52).
  var shared = window.NCDrawerCart && typeof window.NCDrawerCart.subscribe === 'function'
    ? window.NCDrawerCart : null;
  if (shared) shared.subscribe(onCart);

  function checkRush() {
    // Only nc-drawer-minmax.js reads through the shared reader; without it, fetch as before.
    if (shared && shared.minmaxActive) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(onCart)
      .catch(function () {});
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(function () { checkImpressions(); checkRush(); }, 250); }

  function start() {
    var r = root(); if (!r) return false;
    try { document.addEventListener('click', onClick, true); } catch (e) {}
    try { new MutationObserver(schedule).observe(r, { childList: true, subtree: true }); } catch (e) {}
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(function (fn) {
      if (typeof window[fn] === 'function') { try { window[fn](schedule); } catch (e) {} }
    });
    schedule();
    return true;
  }

  var n = 0;
  var poll = setInterval(function () {
    if (window.upcartDocumentOrShadowRoot && start()) { clearInterval(poll); return; }
    if (++n > 100) clearInterval(poll);
  }, 300);
})();
